// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__UdyZE","modalContent":"Modal_modalContent__7Rd46"};